import * as React from 'react';
import HR from 'UIComponents/elements/HR';
import ChooseObjectSection from 'flow-doctor-lib/components/diagnosis/non-enrollment/ChooseObjectSection';
import ChooseTimelineItemSection from 'flow-doctor-lib/components/diagnosis/non-enrollment/ChooseTimelineItemSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChooseObjectAndTimelineItemStep = ({
  flowId,
  objectId,
  objectTypeId,
  setSelectedTimelineItem,
  CrmObjectSelectComponent
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ChooseObjectSection, {
      objectId: objectId,
      objectTypeId: objectTypeId,
      CrmObjectSelectComponent: CrmObjectSelectComponent
    }), !!objectId && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(ChooseTimelineItemSection, {
        flowId: flowId,
        objectId: objectId,
        objectTypeId: objectTypeId,
        setSelectedTimelineItem: setSelectedTimelineItem
      })]
    })]
  });
};
export default ChooseObjectAndTimelineItemStep;